
import React, { useEffect, useState } from "react";
import '../css/admin-custom.css';
import { useNavigate } from "react-router-dom";
const Header = () => {
    
    
    const [isMenuOpen, setMenuOpen] = useState(true);

    const [isDivVisible, setIsDivVisible] = useState(false);
    const toggleDivVisibility = () => {
        setIsDivVisible(!isDivVisible);
    };


    const handleMenuToggle = () => {
        setMenuOpen(!isMenuOpen);
    };
    document.body.classList.toggle('sidenav-toggled', !isMenuOpen);

    const [adminInfo, setAdmininfo] = useState(null);

    useEffect(() => {
        
        const getAdminFromLocalStorage = () => {
            
            const adminDetails = localStorage.getItem('admin-info');
            if (adminDetails) {
                setAdmininfo(JSON.parse(adminDetails));
            }
        };
        getAdminFromLocalStorage();
    }, []);
    
    const navigate = useNavigate();
    function handleLogOut() {
        localStorage.clear();
        navigate('/');
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }
    return (

        <nav className="topnav navbar navbar-expand shadow justify-content-between justify-content-sm-start navbar-dark" id="sidenavAccordion">

        <button className="btn btn-icon btn-transparent-dark order-1 order-lg-0 me-2 ms-lg-2 me-lg-0" onClick={handleMenuToggle}>
            <i className="bi bi-list"></i>
        </button>


        <a className="navbar-brand pe-3 ps-4 ps-lg-2" href="/">
            <img src="../../images/logo.png" alt=" " />
        </a>


        <ul className="navbar-nav align-items-center ms-auto">
            <li className="nav-item dropdown no-caret dropdown-user me-3 me-lg-4">
                {adminInfo ? (<>
                    <span className="btn btn-icon" id="ddUser" onClick={toggleDivVisibility}>
                        {adminInfo.userName == 1 ?
                            <>
                                <img className="img-fluid" src="../images/admin-male.jpg" alt="" />
                            </>
                            :
                            <>
                                <img className="img-fluid" src="../images/admin-female.jpg" alt="" />
                            </>
                        }

                    </span>
                    <div className={`dropdown-menu dropdown-menu-end border-0 shadow fade-in-up ${isDivVisible ? 'd-block' : 'd-none'}`} aria-labelledby="ddUser">
                   
                        <span className="dropdown-item">{adminInfo.username}</span>
                        <span className="dropdown-item">{adminInfo.mobile}</span>
                        <span className="dropdown-item">{adminInfo.email}</span>
                        <div className="dropdown-item">
                            <span className="ftr_link border btn p-1" onClick={handleLogOut}><i className="bi bi-box-arrow-right"></i> Logout</span>
                        </div>
                    </div>
                </>)
                    :
                    <></>
                }
            </li>
        </ul>
    </nav>
    );
};

export default Header;